<template>
    <div class="text-center">
        <v-dialog persistent v-model="visible" width="800">
            <v-card class="not-margin pt-0 pr-0 pl-0">
                <v-toolbar dark color="primary">
                    <div class="text-center">
                        <v-icon>mdi-calendar-edit</v-icon>
                        {{ this.content?.isConsolidacao ? 'Consolidar' : 'Aprovar'}} reagendamento
                    </div>
                </v-toolbar>
                <div class="container dialog">
                    <v-form ref="form" v-if="visible">
                        <v-row class="d-flex justify-center mt-7">
                            <v-col cols="12" class="d-block">
                                <label 
                                for="motivoAlteracao" 
                                style="font-weight: 500">
                                Motivo de alteração
                                </label>
                                <v-textarea 
                                id="motivoAlteracao" 
                                v-model="content.motivoReagendamento.motivoAlteracao" 
                                outlined
                                dense 
                                disabled />
                            </v-col>
                        </v-row>
                        <v-row class="d-flex justify-center">
                            <sigfoco-date-picker 
                                v-model="content.motivoReagendamento.formacaoDataInicio" 
                                label="Antiga Data Início"
                                outlined 
                                disabled
                                dense/>
                            <sigfoco-date-picker 
                                v-model="content.motivoReagendamento.ajusteDataInicio" 
                                label="Nova Data Início"
                                outlined
                                disabled
                                dense/>
                        </v-row>
                        <v-row class="d-flex justify-center">
                            <sigfoco-date-picker 
                                v-model="content.motivoReagendamento.formacaoDataFim"
                                label="Antiga Data Fim"
                                disabled
                                outlined 
                                dense/>
                            <sigfoco-date-picker 
                                v-model="content.motivoReagendamento.ajusteDataFim" 
                                label="Nova Data Fim"
                                outlined
                                disabled
                                dense/>
                        </v-row>
                    </v-form>
                </div>
                <v-row class="d-block text-center btn-group">
                    <v-col cols="12">
                        <v-btn
                            color="primary"
                            @click="aprovar()">
                                {{ this.content?.isConsolidacao ? 'Consolidar' : 'Aprovar'}}
                        </v-btn>
                        <v-btn
                            color="primary"
                            @click="reprovar()">
                                Rejeitar
                        </v-btn>
                        <v-btn
                            color="primary"
                            @click="cancelar()"
                            outlined>
                            Cancelar
                        </v-btn>
                    </v-col>
                </v-row>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import { DialogProps } from '~/commons/classes/dialog-props';
import { Formacao } from '~/commons/classes/formacao';
import tipoReagendamentoEnum from '~/commons/enums/tipo-reagendamento.enum';
import ManterFormacaoService from '~/services/manter-formacao.service';

export default {
    props: new DialogProps(Formacao),
    mixins: [ManterFormacaoService],
    methods: {
        aprovar() {
            if(this.content.qtdReagendamento >= 3){
                this.confirmacaoModalTresAjustes();
            return;
            }
            this.confirmacaoModal('warning', this.content?.isConsolidacao ? 'aprovar' : 'consolidar');
        },
        reprovar() {
            this.confirmacaoModal('error', 'rejeitar');
        },
        cancelar(){
            this.$emit('onClose', this.content);
        },
        confirmacaoModal(type, msg) {
            this.$swal({
            text: `Deseja ${msg} o reagendamento da Solicitação de Formação?`,
            type: type,
            showCancelButton: true,
            confirmButtonText: `Confirmar`,
            cancelButtonText: `Cancelar`,
            }).then(() => {
            this.$AprovarReprovarReagendamento(
                { 
                    ReagendamentoId: this.content.motivoReagendamento?.id,
                    TipoReagendamento: msg == 'rejeitar' ? tipoReagendamentoEnum.REPROVAR : tipoReagendamentoEnum.APROVAR,
                    isConsolidacao: this.content?.isConsolidacao
                },
                this.content.id
            ).then(({ data }) => {
                this.$notifySuccess(data.mensagem);
                this.$emit('onAprove', this.content);
                this.$emit('onClose', this.content);
            })
            }).catch(() => {
                this.$emit('onClose', this.content);
            });
        },
        confirmacaoModalTresAjustes() {
            this.$swal({
                text: `O processo já sofreu TRÊS ajustes, portanto você não pode mais ser reagendado, deseja reprovar?`,
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: `Confirmar`,
                cancelButtonText: `Cancelar`,
                }).then(() => {
                            this.$AprovarReprovarReagendamento(
                        { 
                        ReagendamentoId: this.content.motivoReagendamento?.id,
                        TipoReagendamento: tipoReagendamentoEnum.REPROVAR,
                        isConsolidacao: this.content?.isConsolidacao
                        },
                        this.content.id
                    ).then(({ data }) => {
                        this.$notifySuccess(data.mensagem);
                        this.$emit('onAprove', this.content);
                        this.$emit('onClose', this.content);
                    })
            })
        },
    },
};
</script>